(ns app.front.view.group.admin.import.core
  (:require [app.domain.import.model :as import-model]
            [app.front.entities :as entities]
            [app.front.file.upload :as upload]
            [app.front.ui.radio :as ui-radio]
            [app.front.ui.section :as section]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.core :as acore]
            [app.front.view.group.admin.import.post-processing :as import-further]
            [app.front.view.group.admin.import.session-list :as import-list]
            [app.front.view.group.admin.subs :as gas]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [schema.core :as s]))

(rf/reg-event-fx ::fetch-sessions
  (fn [_ [_ group-id]]
    {:dispatch [:comm/command-monitored {:command    :import/sessions
                                         :method     :get
                                         :data       {:authority-group-id group-id}
                                         :on-success [::entities/merge-entity-db]}]}))

(rf/reg-event-fx ::create-import-session
  (fn [_ [_ group-id file-id filename file-mime-type md5-base64 import-type]]
    {:comm/command {:command    :import/create-session
                    :data       {:authority-group-id group-id
                                 :file-id            file-id
                                 :import-type        import-type
                                 :file/filename      filename
                                 :file/content-type  file-mime-type
                                 :file/md5           md5-base64}
                    :on-success [::create-import-session.success group-id]
                    :notify     {:success :data-import/uploaded}}}))

(rf/reg-event-fx ::create-import-session.success
  (fn [_ [_ group-id status {:keys [session-id data]}]]
    {:route/push {:route  :view/group.admin.import.session
                  :params (util/mmap group-id session-id)}
     :dispatch   [::entities/apply-changes status data]}))

(rf/reg-sub ::selected-import-type :-> ::selected-import-type)

(rf/reg-sub ::import-type
  (fn [[_ group-id]]
    [(rf/subscribe [::selected-import-type])
     (rf/subscribe [::available-import-types group-id])])
  (fn [[selected available]]
    (or selected
        (first available))))

(rf/reg-event-db ::set-import-type
  (fn [db [_ new-type]]
    (assoc db ::selected-import-type new-type)))

(rf/reg-sub ::available-import-types
  (fn [[_ group-id]]
    [(rf/subscribe [::entities/entity group-id])
     (rf/subscribe [::ff/enabled? :feature-flag.id/property-management])
     (rf/subscribe [::ff/enabled? :feature-flag.id/property-data-integrity-tooling])])
  (fn [[group property-management-flag? property-attachment-import-flag?]]
    (import-model/available-import-types group property-management-flag? property-attachment-import-flag?)))

(rf/reg-sub ::loading?
  (fn [[_ group-id]]
    [(rf/subscribe [:comm/command-processing? :import/sessions])
     (rf/subscribe [::acore/fetching-config? group-id :group/configuration])])
  (fn [[loading-sessions? loading-config?] _]
    (or loading-sessions? loading-config?)))

(defn view [{{{:keys [group-id]} :path} :parameters :as match}]
  (let [tr          (<sub [::gas/group-tr])
        import-type (<sub [::import-type group-id])]
    [acommon/admin-page-v2
     (util/mmap {:title (tr [:view/group.admin.import])}
                match)
     (if (<sub [::loading? group-id])
       [:div [section/section-skeleton] [section/section-skeleton]]
       [:div
        [import-list/session-list (util/mmap group-id)]
        [:section
         [:h3 (tr [:data-import/create-session])]
         [ui-radio/radio
          {:name      "import-type"
           :values    (<sub [::available-import-types group-id])
           :val->str  (comp tr vector)
           :value     import-type
           :on-change #(>evt [::set-import-type %])}]
         [upload/upload-area "start-new-import-session-upload"
          {:accept-types    ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                             "application/vnd.ms-excel"]
           :additional-help (tr [:data-import/upload-help])
           :attach-file-fn  (fn [file-id filename file-mime-type md5-base64]
                              (>evt [::create-import-session
                                     group-id
                                     file-id
                                     filename
                                     file-mime-type
                                     md5-base64
                                     import-type]))}]]
        [import-further/post-processing-section (util/mmap tr group-id)]])]))

(def route
  {:name        :view/group.admin.import
   :view        view
   :public?     false
   :own-layout? true
   :parameters  {:path {:group-id s/Int}}
   :controllers [{:parameters {:path [:group-id]}
                  :start      (fn [{{:keys [group-id]} :path}]
                                (>evt [::fetch-sessions group-id]))}]})
